import React, { useContext } from 'react';
import { renderValue } from '../../utilities/utils';
import { ChangelogContext } from '../ChangelogTable/ChangelogContext';
import { useTranslation } from '@michelin/central-provider';
const CustomCell = (props) => {
    const { value, data, metadata, field } = props;
    const { t } = useTranslation();
    const context = useContext(ChangelogContext);
    return (React.createElement("div", null, renderValue(t, value, metadata[data.entity] || metadata['*'], context, data, undefined, undefined, undefined, field)));
};
export default CustomCell;
//# sourceMappingURL=CustomCell.js.map